import { db } from "@/main";

export default {
    state: {
      orderList: [],
      show: '',
      unsuscribe: null,
      status: [
        {
          label: 'Pendiente',
          text: 'Pendiente',
          value: 'pending',
          class: 'primary'
        }, {
          label: 'Programado',
          text: 'Programado',
          value: 'programmed',
          class: 'warning'
        }, { 
          label: 'Reprogramado',
          text:  'Reprogramado',
          value: 'rescheduled',
          class: 'info'
        }, { 
          label: 'Cancelado', 
          text: 'Cancelado', 
          value: 'canceled',
          class: 'danger' 
        }, { 
          label: 'Realizado', 
          text: 'Realizado', 
          value: 'completed',
          class: 'success'
        }, { 
          label: 'Archivado', 
          text: 'Archivado', 
          value: 'archived',
          class: 'success'
        }
      ],
      options: [{
        value: 'solid',
        label: 'Sólido',
        unit: [
          {
            label: 'Tambor/es',
            value: 'drum'
          },
        ]
      }, {
        value: 'water',
        label: 'Agua',
        unit: [
          {
            label: 'm3 (Granel)',
            value: 'm3'
          }, {
            label: 'Tambor/es',
            value: 'drum'
          },
        ]
      }, {
        value: 'mud',
        label: 'Barro',
        unit: [
          {
            label: 'm3 (Granel)',
            value: 'm3'
          }, {
            label: 'Tambor/es',
            value: 'drum'
          },
        ]
      }, {
        value: 'oil',
        label: 'Aceite',
        unit: [
          {
            label: 'Tambor/es',
            value: 'drum'
          },
        ]
      }],
    },
    mutations: {
      ADD_ORDER( state, order ) {
        state.orderList.push(order)
      },
      UPDATE_ORDER( state, order ) {
        let index = state.orderList.findIndex(
          obj => obj.id == order.id
        );
        if( index != -1 )
          state.orderList.splice(index, 1, order);
      },
      DELETE_ORDER( state, order ) {
        let index = state.orderList.findIndex(
          obj => obj.id == order.id
        );
        if( index != -1 )
          state.orderList.splice(index, 1);
      },
      CLEAR_ORDERS( state ) {
        state.orderList = []
      },
      SET_ORDER_SHOW_TYPE( state, show ) {
        state.show = show
      }
    },
    actions: {
        getOrders( { state, rootState, commit } ) {
          commit('CLEAR_ORDERS')
          if( state.unsuscribe )
            state.unsuscribe()

          return new Promise((resolve, reject) => {

              let dbRef = db.collection("orders")
              var query

              if( state.show === 'pending' && rootState.current_user.role === 'driver' ) {
                query = dbRef.where('status', 'in', ['programmed', 'rescheduled'])
                query = dbRef.where('manifest', '>', '')
              } else if( state.show === 'pending' && rootState.current_user.role === 'commercial' )
                query = dbRef.where('status', 'in', ['programmed', 'rescheduled']) 
              else if( state.show === 'pending' )
                query = dbRef.where('status', 'in', ['pending', 'programmed', 'rescheduled'])
              else if( state.show === 'completed')
                query = dbRef.where('status', 'in', ['completed'])
              else
                query = dbRef
              
              // Current date
              const now = new Date()
              now.setHours(0,0,0,0)

              state.unsuscribe = query.onSnapshot(snap => {
                  
                  snap.docChanges().forEach(change => {
                      const order = change.doc.data()
                      // Fill the order with extra data
                      order.id = change.doc.id

                      // Add date_class="expired" when programmed date is previus of now
                      order.date_class = ''
                      if( order.date ) {
                        order.date_text = order.date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1');
                        const newOrderDate = new Date(order.date+"T00:00:00")
                        
                        if( newOrderDate < now && order.status != 'completed' && order.status != 'canceled' && order.status != 'archived')                         
                          order.date_class = 'expired'
                      } else {
                        order.date = ''
                      }
                      
                      const status = state.status.find( e => e.value === order.status)
                      order.status_class = status.class // ej. warning
                      order.status_label = status.label // ej. Programado
                      
                      //let zone = rootState.zones.zoneList.find(element => element.id == order.zone_id)
                      //order.zone = zone ? zone.name : '' // ej. Oeste

                      let trash = state.options.find(element => element.value == order.trash_type)
                      order.trash_type_t = trash ? trash.label : order.trash_type // ej. Aceite

                      let trash_unit = trash?.unit.find(element => element.value == order.trash_unit)
                      order.trash_unit_t = trash_unit ? trash_unit.label : 'Tambor/es' // ej. 2 tambor/es
                      
                      const activity = rootState.users.activities.find( e => e.value == order.activity )
                      if( activity )
                        order.activity_t = activity.text

                      if (change.type === "added") { 
                          let orderTmp = state.orderList.find( e => e.id === order.id )
                          if( !orderTmp )                                              
                            commit('ADD_ORDER', order)
                      }
                      else if (change.type === "modified") {
                          commit( 'UPDATE_ORDER', order )
                      }
                      else if (change.type === "removed") {
                          commit( 'DELETE_ORDER', order )
                      }
                  });
                  resolve()
              }, function(error) {
                  commit('SET_ERROR', { section: 'Orders', function: 'getOrders', msg: error });
                  reject()
              });
          })
        },
        addOrder( { commit }, order ) {
            // Remove local info before store en DB
            delete order.status_class
            delete order.status_label
            delete order.date_class
            delete order.date_text
            delete order.trash_type_t
            delete order.trash_unit_t
            delete order.activity_t

            return new Promise((resolve, reject) => {
                db.collection("orders")
                .add(order)
                .then(function(docRef) {
                    // Do this in getOrders, that is call by FireStore when DB change
                    //order.id = docRef.id;
                    //commit( 'ADD_ORDER', order )
                    resolve()
                })
                .catch(function(error) {
                  commit('SET_ERROR', { section: 'Orders', function: 'addOrder', msg: error });
                  reject()
                })
            })
        },
        updateOrder( { commit }, order ) {
            // Remove local info before store en DB
            delete order.status_class
            delete order.status_label
            delete order.date_class
            delete order.date_text
            delete order.trash_type_t
            delete order.trash_unit_t
            delete order.activity_t
            
            return new Promise((resolve, reject) => {
                db.collection("orders")
                .doc(order.id)
                .update(order)
                .then(() => {
                    // Do this in getOrders, that is call by FireStore when DB change  
                    //commit( 'UPDATE_ORDER', order )
                    resolve()
                })
                .catch(function(error) {
                  commit('SET_ERROR', { section: 'Orders', function: 'updateOrder', msg: error });
                  reject()
                })
            })
        },
        deleteOrder( { commit }, order ) {
            return new Promise((resolve, reject) => {
                db.collection("orders")
                .doc(order.id)
                .delete()
                .then(function() {
                    // Do this in getOrders, that is call by FireStore when DB change
                    //commit( 'DELETE_ORDER', order )
                    resolve()
                })
                .catch(function(error) {
                  commit('SET_ERROR', { section: 'Orders', function: 'deleteOrder', msg: error });
                  reject()
                });
            })
        },
        getOrdersFromDate( { state, commit }, date ) {
          return new Promise((resolve, reject) => {
            db.collection("orders")
            .where("date", "==", date)
            .where('status', 'in', ['programmed', 'rescheduled'])
            .get().then(function(querySnapshot) {
              let result = []
              querySnapshot.forEach(function(doc) {
                const order = doc.data()
                order.id = doc.id
                result.push(order);
              });
              resolve(result)
            }).catch(function(error) {
              commit('SET_ERROR', { section: 'Orders', function: 'getOrdersFromDate', msg: error });
              reject()
            })
          })
        },
        getNextProgrammedOrder( { state, commit } ) {

          // Current date
          const now = new Date()
          now.setHours(0,0,0,0)
          const nowString = now.toISOString().slice(0,10);

          return new Promise((resolve, reject) => {
            db.collection("orders")
            .where("date", ">=", nowString)
            .where('status', 'in', ['programmed', 'rescheduled'])
            .orderBy("date").limit(1)
            .get().then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                resolve(doc.data());
              });
            }).catch(function(error) {
              commit('SET_ERROR', { section: 'Orders', function: 'getNextProgrammedOrder', msg: error });
              reject()
            })
          })
        },
        unsuscribeOrder( { state } ) {
          if( state.unsuscribe )
            return state.unsuscribe()
          return true
        }
    }
}